import React from 'react';
import { useHistory } from 'react-router-dom';
import routesConfig from 'constants/routesConfig.json';
import { HelpCircleFilled, Users } from 'icons/untitledui';
import * as Styled from 'teamProfiles/styles/ProfileLink.style';

interface ProfileLinkProps {
  name: string;
  profileId?: string;
  hasProfile?: boolean;
}

export default function ProfileLink({
  name,
  profileId,
  hasProfile = true,
}: ProfileLinkProps): JSX.Element {
  const history = useHistory();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (profileId) {
      history.push(`${routesConfig.TEAM_PAGE}/${profileId}`);
    }
  };

  const isLinked = hasProfile || !!profileId;

  return (
    <Styled.Link
      onClick={handleClick}
      style={{ cursor: profileId ? 'pointer' : 'default' }}
    >
      {name}
      {isLinked ? (
        <Styled.ProfileIconUser>
          <Users.User02 size={16} />
        </Styled.ProfileIconUser>
      ) : (
        <Styled.ProfileIcon>
          <HelpCircleFilled size={16} />
        </Styled.ProfileIcon>
      )}
    </Styled.Link>
  );
}
